export default __webpack_public_path__ + "static/media/loading.1dfb1c5a.svg";